import Vue from 'vue';
import App from './App.vue';
import store from './store';
import { playSound } from './utils/playSound';
import { Howler } from 'howler';
import { namespace } from 'vuex-class';

Vue.config.productionTip = false;

(window as any).store = store;

declare const sgSdk: any;

const languages = require('./utils/languages.json')

const puzzle = namespace('Puzzle');

let sgSettings: any;
let sdkHandler: any;

// @ts-ignore
window.onWrapperReady = () => {
  sgSdk.initialize(
    ['basic', 'scoreGame'],
    {
      id: 'wordsearch',
      build: '1.0.0',
      supportedLanguages: ['en'],
      runGame: () => {
        // do something?
        new Vue({
          store,
          render: (h) => h(App),
        }).$mount('#app');
        sdkHandler.trigger('start');
        sdkHandler.trigger('gameStart');
        sgSdk.setAdClosedCallback(() => { window.focus() });
        if (document.hasFocus()) playSound("musicSound");
      },
      startOver: () => {
        // ignore
      },
      freezeGame: () => {
        Howler.mute(true)
      },
      unfreezeGame: () => {
        Howler.mute(false)
      },
    },
    async (error: any, settings: any, handler: any) => {
      sgSettings = settings;
      sdkHandler = handler;

      (window as any).sdkHandler = sdkHandler;

      try {
        (window as any).locale = settings.config.env.locale;
      } catch (e) {
        (window as any).locale = 'en';
      }

      (window as any).languages = languages[(window as any).locale];

      sdkHandler.trigger('loading.completed', {
        callback: (loadingError: any) => {
          if (loadingError) console.warn(loadingError);
        }
      });
    }
  );
}
